<template>
    <div class="admin">
        <navigation />
        <div class="admin-content">
            <router-view />
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Navigation from '../../components/Admin/Navigation';

export default {
    components : {
        'navigation' : Navigation
    },
    beforeCreate(){
        axios.interceptors.request.use((config) => {
            var token = sessionStorage.getItem('access_token');
            config.headers["Authorization"] = `Bearer ${token}`;
            return config;
        });

        axios.get(location.protocol + '/api/Admin/CheckValid')
        .then()
        .catch(e => {
            if (e.response.status === 401 || e.response.status === 403) {
                this.$router.push('/login');
            }
        })
    }
}
</script>

<style lang="scss">
.admin{
    width: calc(100% - 300px);
    min-height: 100%;
    padding-left: 300px;
}

.admin-content{
    width: 100%;
    height: 100%;
}
</style>